!((document, Drupal, $) => {
  "use strict";

  Drupal.behaviors.accordion = {
    attach: function (context) {
      const accordions = document.querySelectorAll(".accordion");

      const resizeActive = (content) => {
        if (content.classList.contains("accordion--is-active")) {
          const accordionContent = content.querySelector(".accordion__content");
          accordionContent.style.height = "auto";
          accordionContent.style.height = `${accordionContent.scrollHeight}px`;
        }
      };

      const openAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");

        accordion.querySelector(".accordion__title").setAttribute("aria-expanded", true);
        accordion.classList.add("accordion--is-active");
        content.removeAttribute("inert");

        const adjustHeight = () => {
          content.style.height = "auto"; // Reset the height first
          content.style.height = `${content.scrollHeight}px`; // Set the height based on the new scroll height
        };

        // Check if the content exceeds the height of the accordion content
        if (content.scrollHeight > content.clientHeight) {
          // If the content is taller than the accordion, enable scrolling
          content.style.overflowY = "auto";
        }

        // Listen for changes in content size (if needed)
        // You may need additional logic to handle content changes dynamically
        // content.addEventListener("change", adjustHeight);

        // Call adjustHeight to initially set the height
        adjustHeight();
      };

      const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        accordion
          .querySelector(".accordion__title")
          .setAttribute("aria-expanded", false);
        accordion.classList.remove("accordion--is-active");
        content.setAttribute("inert", "");
        content.style.height = "0px";
      };

      $(document).on('click', function (e) {
        var target = $(this).attr('href');
        var targetAccordion = $(target).closest('.accordion')[0];
        if (targetAccordion && targetAccordion.classList.contains('accordion')) {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(targetAccordion);
          window.addEventListener("resize", () => {
            resizeActive(targetAccordion);
          });
        }
      });

      $(document).ready(function() {
        // Get the fragment identifier from the URL
        var fragmentIdentifier = window.location.hash;

        // Define the offset value you want (adjust this as needed)
        var offset = 350; // Adjust this value to control the offset
        // Check if the fragment identifier corresponds to an accordion section
        if (fragmentIdentifier) {
          var targetAccordionContent = $(fragmentIdentifier);

          // Check if the targetAccordionContent exists and is inside an accordion
          if (targetAccordionContent.length && targetAccordionContent.closest('.accordion').length) {
            // Open the accordion
            targetAccordionContent.closest('.accordion').addClass('accordion--is-active');
            targetAccordionContent.closest('.accordion').find('.accordion__title').attr('aria-expanded', true);
            targetAccordionContent.closest('.accordion').find('.accordion__content').css('height', '200px');
            openAccordion(targetAccordionContent);
            targetAccordionContent.css('height', targetAccordionContent.prop('scrollHeight') + 'px');

            // Calculate the target scroll position with the offset
            var targetPosition = targetAccordionContent.offset().top - offset;

            // Scroll to the target position
            $('html, body').animate({
              scrollTop: targetPosition
            }, 1000); // You can adjust the animation duration as needed

          }
        }
      });

      // Add a click event listener to all anchor links
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent the default scroll behavior

          // Get the target element based on the anchor's href attribute
          const targetId = this.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            // Calculate the target scroll position (adjust the offset as needed)
            const offset = 350; // Adjust this value to control the offset
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
            console.log(targetPosition);
            // Scroll to the target position smoothly
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        });
      });

      // Handle anchor link clicks first
      $(document).on('click', 'a[href^="#"]', function (e) {
        var target = $(this).attr('href');
        var targetAccordion = $(target).closest('.accordion')[0];
        if (targetAccordion && targetAccordion.classList.contains('accordion')) {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(targetAccordion);
          window.addEventListener("resize", () => {
            resizeActive(targetAccordion);
          });
        }
      });

      if (accordions) {
        accordions.forEach((accordion, index) => {
          const accordionTitle = accordion.querySelector(".accordion__heading");

          // Opens the first accordion on load
          if (index == 0) {
            if (accordion.classList.contains('accordion--expanded')) {
              openAccordion(accordion);
            }
          }

          accordionTitle.onclick = () => {
            if (accordion.classList.contains("accordion--is-active")) {
              window.removeEventListener("resize", resizeActive);
              closeAccordion(accordion);
            } else {
              accordions.forEach((accordion) => closeAccordion(accordion));
              openAccordion(accordion);
              window.addEventListener("resize", () => {
                resizeActive(accordion);
              });
            }
          };
        });
      }
    },
  };
})(document, Drupal, jQuery);
